import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { Table, Layout, Space, Row, Col, Button, Modal } from 'antd'
import { format } from "date-fns"
import {
  // EditOutlined,
  DeleteOutlined,
  PrinterOutlined,
  ExportOutlined,
  ArrowRightOutlined,
  EyeFilled
} from "@ant-design/icons"

import ReactToPrint from 'react-to-print'

import usePaginate from '../../firebase/hooks/usePaginate'
import { useStore } from "../../contexts/FireStoreContext"
import FireStoreSearch from "../../components/FilterSearch"
import { useAuth } from "../../contexts/AuthContext"
import PageLimitDropDown from "../../components/PageLimitDropDown"
import useExportToCSV from "../../components/ReactPDF/useExportToCSV"

import FilterByDate from "../../components/FilterByDate"
import { usePrice } from "../../hooks/usePrice"
// import { Timestamp } from "firebase/firestore"
const { Content } = Layout

const table = "transactions"
// const where = ['status', "==", 'initiated']

const searchOptions = [
  {
    'key': 'from.country',
    'label': 'Country'
  },
  {
    'key': 'from.firstName',
    'label': 'Name'
  },
  {
    'key': 'from.bank',
    'label': 'Bank'
  },
  {
    'key': 'from.branch',
    'label': 'Branch'
  }
]

const Transactions = () => {
  const tableRef = useRef()
  const history = useHistory()
  const { pathname } = useLocation()
  const { deleteDocument } = useStore()
  const { user } = useAuth()
  const [list, setList] = useState([])
  const [showMore, setShowMore] = useState(true)
  const { exportCSV } = useExportToCSV()
  const { price } = usePrice()

  // const start = moment().utc().endOf('day').valueOf()
  // const end = moment().subtract(1, "days").utc().startOf("day").valueOf()
  // const start = Timestamp.fromMillis(moment().utc().endOf('day').valueOf())
  // const end = Timestamp.fromMillis(moment().utc().subtract(8, "days").startOf("day").valueOf())

  // console.log(moment(start.toDate()).format())
  // console.log(moment(end.toDate()).format())

  const where = user.role === 'agent' ? ['to.iso2', "==", user.iso2] : []

  const {
    loading,
    loadingMore,
    hasMore,
    items,
    loadMore
  } = usePaginate(table, {
    where: where,
    // where: where,
    // where: ["transactionAt", "<=", parseInt(today)],
    // where: ["updatedAt", "<=", start],
    // between: ["transactionAt", start, end],
    // between: ["date", today, yesterDay],
    // where: ["firstName", "==", 'John'],
    orderBy: ["transactionAt", "desc"],
    // orderBy: ["status", "desc"],
    limit: user.limit,
  })


  useEffect(() => {
    setList(items)
  }, [items])

  // console.table(list)

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list)
      setShowMore(false)
    } else {
      setList(items)
      setShowMore(true)
    }
  }

  const columns = [
    {
      title: 'Transaction Id',
      dataIndex: 'id',
      key: 'id',
      // filters: {},
      // sorter: true,
      // sorter: (a, b) => a.transactionAt.length - b.transactionAt.length,
      // sortDirections: ['ascend', 'descend'],
      // render: (transactionAt, row) => <span>{transactionAt} {row?.from?.lastName}</span>
      // render: (transactionAt, row) => <span>{moment(row?.updatedAt?.toDate()).utc().format()} {row?.from?.lastName}</span>
    },
    {
      title: 'Name',
      dataIndex: ['from', 'firstName'],
      key: 'firstName',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.firstName.length - b.firstName.length,
      sortDirections: ['ascend', 'descend'],
      render: (firstName, row) => <span>{firstName} {row?.from?.lastName}</span>
      // render: (firstName, row) => <span>{moment(row?.updatedAt?.toDate()).utc().format()} {row?.from?.lastName}</span>
    },
    {
      title: 'Bank',
      dataIndex: ['from', 'bank'],
      key: 'bank',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.bank.length - b.bank.length,
      responsive: ['md'],
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Branch',
      dataIndex: ['from', 'branch'],
      key: 'branch',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.branch.length - b.branch.length,
      responsive: ['md'],
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Region',
      dataIndex: ['from', 'state'],
      key: 'region',
      // filters: {},
      // sorter: true,
      sorter: (a, b) => a.region.length - b.region.length,
      responsive: ['md'],
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Country',
      dataIndex: ['from', 'country'],
      key: 'country',
      // sorter: true,
      sorter: (a, b) => a.country.length - b.country.length,
      responsive: ['md'],
      sortDirections: ['ascend', 'descend'],
      render: (_, row) => <div>{row?.from.country} <ArrowRightOutlined /> {row?.to.country}</div>
    },
    {
      title: 'Amount',
      dataIndex: 'sendAmount',
      key: 'sendAmount',
      // sorter: true,
      sorter: (a, b) => a.sendAmount.length - b.sendAmount.length,
      sortDirections: ['ascend', 'descend'],
      render: (sendAmount) => <span>{price(sendAmount)}</span>
    },
    // {
    //   title: 'Date',
    //   dataIndex: 'createdAt',
    //   key: 'createdAt',
    //   render: createdAt => (createdAt.toDate())
    // },
    {
      title: 'Actions',
      className: 'table-actions',
      dataIndex: 'id',
      key: 'id',
      render: (id, row) => (
        <Space size="middle">
          <EyeFilled onClick={() => history.push(`${pathname}/view/${row.id}`, row)} />
          {/* <EditOutlined onClick={(row) => history.push(`${pathname}/edit/${row.id}`, row)} /> */}
          <DeleteOutlined style={{ color: "#ff0000" }} onClick={() => deleteConfirm(row)} />
        </Space>
      )
    }
  ]

  const deleteConfirm = (item) => {
    Modal.confirm({
      title: "Are you sure?",
      content: <>
        <div>You want to delete <b>{item.bankName}</b>?</div>
        <small>After delete, Data can't be recovered.</small>
      </>,
      centered: true,
      // onCancel: handleCancel,
      cancelText: "No",
      onOk: () => deleteDocument(table, item.id, item.bankName),
      okText: "Yes",
      cancelButtonProps: {
        danger: true
      },
      okButtonProps: {
        danger: true
      }
    })
  }

  const onChange = (data) => {
    console.log(data)
  }

  const handleExport = () => {
    exportCSV(items.map(item => (
      {
        "Amount": (item?.sendAmount),
        "Total Amount": item?.totalAmount,
        "Sender Name": item?.from?.firstName + ' ' + item?.from?.lastName,
        "Sender Bank": item?.from?.bank,
        "Sender Branch": item?.from?.branch,
        "Sender Bank Account No": item?.from?.accountNo,
        "Sender SSN": item?.from?.ssn,
        "Sender Address 1": item?.from?.address1,
        "Sender Address 2": item?.from?.address2,
        "Sender Zip Code": item?.from?.zipcode,
        "Sender Region": item?.from?.state,
        "Sender Country": item?.from?.country,
        "Payment Type": item?.from?.paymentType,
        "Sender Routing No": item?.from?.routingNo,
        "Receiver Name": item?.to?.firstName + ' ' + item?.to?.lastName,
        "Receiver Bank": item?.to?.bank,
        "Receiver Bank Account No": item?.to?.accountNo,
        "Receiver Branch": item?.to?.branch,
        "Receiver Address 1": item?.to?.address1,
        "Receiver Address 2": item?.to?.address2,
        "Receiver Country": item?.to?.country,
        "Receiver Amount": item?.sendAmount,
      }
    )), { filename: `transactions-${format(new Date(), 'dd-MM-yyyy')}` })
  }

  return (
    <Content>
      <div className="" style={{ padding: 16, minHeight: 360 }}>
        <Row justify="space-between" style={{ marginBottom: "1em" }}>
          <Col xs={18} lg={12}>
            <Space>
              <FilterByDate table={table} column="transactionAt" setResult={setResult} stickyCondition={where} />
              <FireStoreSearch table={table} searchOptions={searchOptions} setResult={setResult} stickyCondition={where} />
            </Space>
          </Col>
          <Col xs={6} lg={12} className="text-right">
          <Space>
              <Button type="primary" onClick={handleExport}>Export <ExportOutlined /></Button>
              <ReactToPrint
                trigger={() => <Button type="primary">Print <PrinterOutlined /></Button>}
                content={() => tableRef.current}
              />
            </Space>
          </Col>
        </Row>
        <Table
          rowKey="id"
          dataSource={list}
          columns={columns}
          loading={loading}
          onChange={onChange}
          pagination={false}
          ref={tableRef}
        />
        <Row justify="space-between" style={{ marginTop: "1.5em" }}>
          <Col>
            <PageLimitDropDown />
          </Col>
          <Col>
            {showMore && hasMore && !loadingMore && <Button type="primary" onClick={loadMore}>Load More</Button>}
            {loadingMore && <Button type="primary" loading>Loading...</Button>}
          </Col>
        </Row>
      </div>
    </Content>
  )
}

export default Transactions
